import { Component, PLATFORM_ID, inject } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { NavbarComponent } from '../navbar/navbar.component';
import { HeaderComponent } from '../header/header.component';
import { Router } from '@angular/router';

interface ContactItem {
  name: string;
  phone: string;
}

@Component({
  selector: 'app-contacts',
  standalone: true,
  imports: [CommonModule, NavbarComponent, HeaderComponent],
  templateUrl: './contacts.component.html',
  styleUrl: './contacts.component.css'
})
export class ContactsComponent {
  private readonly router = inject(Router);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly isBrowser = isPlatformBrowser(this.platformId);

  contacts: ContactItem[] = [
    { name: 'James Stockdale Ltd', phone: '07860113198' },
    { name: 'AB Texel UK  Ltd', phone: '01733359015' },
    { name: 'D R & F A Ford Transport Ltd', phone: '07970758224' },
    { name: 'Scarborough & Wombourne Field Office', phone: '01723580253' },
    { name: 'Whittlesey Field Office', phone: '01733200062' }
  ];

  onDial(phone: string, event: Event): void {
    if (!this.isBrowser) {
      return;
    }

    event.preventDefault();
    const isMobile = /Mobi|Android/i.test(navigator.userAgent) || (globalThis.innerWidth <= 812);
    const tel = `tel:${phone}`;
    if (isMobile) {
      this.navigateToTel(tel);
    } else {
      window.open(tel, '_self');
    }
  }

  /** Navigate to tel: URL - extracted for testability */
  navigateToTel(tel: string): void {
    this.performLocationAssign(tel);
  }

  /** @internal Wraps location.assign so tests can override without touching the non-configurable browser property */
  protected performLocationAssign(url: string): void {
    globalThis.location.assign(url);
  }

  async onCopy(phone: string = ''): Promise<void> {
    if (!this.isBrowser) return;

    const text = phone;
    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        return;
      }
    } catch (err) {
      console.warn('Clipboard API failed, falling back to legacy copy', err);
    }

    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    // Note: execCommand is deprecated but needed for fallback compatibility
    // eslint-disable-next-line deprecation/deprecation
    document.execCommand('copy');
    textarea.remove();
  }

  onNavChange(id: string): void {
    switch ((id || '').toLowerCase()) {
      case 'profile':
        this.router.navigateByUrl('/profile');
        break;
      case 'home':
        this.router.navigateByUrl('/growers');
        break;
      case 'contacts':
        this.router.navigateByUrl('/contacts');
        break;
      default:
        this.router.navigateByUrl('/contacts');
    }
  }
}


